import React from 'react';
import Logo from 'url:../../../src/img/logo.png';
import styles from 'bundle-text:./styles.css';
import 'regenerator-runtime/runtime'

const Thanks = ({ isOpen = false, onAccept = ()=>{ } }) => (
    <React.Fragment>
        <style>
            {styles}
        </style>
        <div className={`bg_thank ${isOpen ? 'active': ''}`}>
            <div className={`container__alert ${isOpen ? 'active': ''}`}>
            <button className='btn__cross' onClick={onAccept}>×</button>
                <div className="mobile__image"></div>
                <div className="body__alert">
                    <h1 className="title">Thank you for contacting us!</h1>
                    <h1 className="text">We will get back <br/> to you shortly</h1>
                    <button className="btn btn__accept" onClick={onAccept}>
                        Accept
                    </button>
                </div>
                <div className="body__alert empty__space"></div>
            </div>
        </div>
    </React.Fragment >
)

export default Thanks;